export class LruCache<K, V> {
  private map = new Map<K, V>()

  constructor(private readonly maxEntries: number) {}

  get(key: K): V | undefined {
    const value = this.map.get(key)

    if (value === undefined) return undefined
    // refresh LRU order
    this.map.delete(key)
    this.map.set(key, value)
    return value
  }

  set(key: K, value: V): void {
    if (this.map.has(key)) {
      this.map.delete(key)
    }

    this.map.set(key, value)
    if (this.map.size > this.maxEntries) {
      const oldestKey = this.map.keys().next().value as K | undefined

      if (oldestKey !== undefined) this.map.delete(oldestKey)
    }
  }
}
